<template>
  <div class="pagi">
    <button @click="previousPage" v-if="summary.currStart > 1">Previous</button>

    <strong class="pagi-summ bold"
      >{{ summary.currStart }}-{{ summary.currEnd }} of
      {{ summary.fullyMatching }} events</strong
    >

    <button @click="nextPage" v-if="summary.currEnd < summary.fullyMatching">
      Next
    </button>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: ["summary"],
  components: {},
  data() {
    return {};
  },
  methods: {
    nextPage() {
      if (this.summary.currEnd < this.summary.fullyMatching) {
        this.$emit("nextPage");
        this.scrollTop();
      }
      return;
    },
    previousPage() {
      if (this.summary.currStart > 1) {
        this.$emit("previousPage");
        this.scrollTop();
      }
      return;
    },
    scrollTop() {
      const eventsContainer = document.querySelector("#app");
      eventsContainer.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
  },
};
</script>

<style lang="scss">
.pagi {
  display: flex;
  justify-content: center;
  align-items: center;

  .pagi-summ {
    margin: 0 1rem;
  }
}
</style>